import React from 'react';
import PropTypes from 'prop-types';
import UserTimeFormat from '../../../components/user-time-format';
import { formatTimeFrom24Hour } from '../../../services/time-helper-service';

const StartThroughClosingTime = ({ startTime, endTime }) => (
  <div>
    <UserTimeFormat value={formatTimeFrom24Hour(startTime)} />
    {' - '}
    <UserTimeFormat value={formatTimeFrom24Hour(endTime)} />
  </div>
);

StartThroughClosingTime.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
};

export default StartThroughClosingTime;
